import * as actionType from "./actionTypes";
import { createReducer, updateObject } from "../../utils/reducerUtils";

/* State shape same as initial state
*/
const initialState = {
  subscribers: [],
};

const setSubscribers = (state, action) => (
  updateObject(state, {
    subscribers: action.subscribers,
  })
);

const reducer = createReducer(initialState, {
  [actionType.SET_SUBSCRIBERS]: setSubscribers,
});

export default reducer;

// SELECTORS
export const getSubscribers = (state) => state.subscribers;
